import React, { useState, useEffect } from 'react';
import SubHeader from '../components/SubHeader/SubHeader';
import Footer from '../components/Footer/Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTicket, faChartLine, faCalendarAlt, faChevronRight, faRotate } from '@fortawesome/free-solid-svg-icons';
import '../styles/TicketStatistics.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { APP_VERSION, CACHE_VERSION } from '../config/appConfig';

function TicketStatistics() {
  const navigate = useNavigate();
  const [isUpdating, setIsUpdating] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Kiểm tra nếu có param clear_cache=true
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('clear_cache') === 'true') {
      handleUpdateApp();
      // Xóa param sau khi xử lý
      navigate('/ticket-statistics', { replace: true });
    }
  }, [location]);

  const reportItems = [
    {
      id: 1,
      title: 'Báo cáo vé',
      icon: faTicket,
      path: '/daily-tickets'
    },
    {
      id: 2,
      title: 'Báo cáo ca làm việc',
      icon: faCalendarAlt,
      path: '/shift-report'
    }
  ];

  const handleUpdateApp = async () => {
    if ('serviceWorker' in navigator) {
      try {
        setIsUpdating(true);
        
        // Xóa tất cả cache
        const cacheKeys = await caches.keys();
        await Promise.all(cacheKeys.map(key => caches.delete(key)));
        
        // Reload trang
        window.location.reload(true);
      } catch (error) {
        console.error('Lỗi khi cập nhật:', error);
        setIsUpdating(false);
        alert('Không thể cập nhật. Vui lòng thử lại sau.');
      }
    }
  };

  return (
    <div className="ticket-statistics">
      <SubHeader title="Báo cáo" />
      <main className="ticket-statistics-main">
        <div className="report-list">
          {reportItems.map((item) => (
            <div 
              key={item.id} 
              className="report-item"
              onClick={() => navigate(item.path)}
            >
              <div className="report-item-content">
                <div className="report-icon">
                  <FontAwesomeIcon icon={item.icon} />
                </div>
                <span className="report-title">{item.title}</span>
              </div>
              <FontAwesomeIcon icon={faChevronRight} className="chevron-icon" />
            </div>
          ))}
        </div>

        <div className="app-version-info">
          <p>Phiên bản: {APP_VERSION}</p>
          <p className="cache-version">Cache: {CACHE_VERSION}</p>
          <button 
            className="update-app-btn" 
            onClick={handleUpdateApp}
            disabled={isUpdating}
          >
            <FontAwesomeIcon icon={faRotate} spin={isUpdating} />
            <span>{isUpdating ? 'Đang cập nhật...' : 'Cập nhật phần mềm'}</span>
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default TicketStatistics;
